module.exports = "## Chip\n\n[Chips](https://www.google.com/design/spec/components/chips.html) \nrepresent complex entities in small blocks, such as a contact.\n\nWhile included here as a standalone component, the most common use will\nbe in some form of input, so some of the behaviour demonstrated is not\nshown in context.\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/Chip/README.md
 ** module id = 952
 ** module chunks = 0
 **/